import React, { useEffect, useState } from "react";
import {
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { ServiceApi } from "../services/index.service";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import AddPromotionDialog from "./AddPromotionDialog";
import dayjs from "dayjs";
import CreativesNonMandatoryPromotions from "./Creatives/CreativesNonMandatoryPromotions";


const DMBPromosPreSellBoardConfiguration = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [btnloading, setBtnLoading] = useState(false);
  const [nonMandatoryList, setNonMandatoryList] = useState([]);
  const initival = {
      intCreativeID: 0,
      vchCreativeName: "",
      bitActive: 0,
      bitMandatory: 0,
      vchImageURL1: '',
      vchImageURL2: '',
      vchImageURL3: '',
      dteStartDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      dteEndDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      dteDateCreated: dayjs().format('YYYY-MM-DD HH:mm:ss'),
  };
  const [selectedCreative, setSelectedCreative] = useState(initival);
  const [action, setAction] = useState("Add");
  const [showDialog, setShowDialog] = useState(false);
  const { storage } = useSelector((state) => state);

  const handleCloseDialog = () => {
    setShowDialog(false);
    setSelectedCreative(initival);
    setAction("Add");
  };

  const handleEdit = (dataItem) => {
    setAction("Update");
    setSelectedCreative(dataItem);
    setShowDialog(true);
  };
  const handleDelete = async (dataItem) => {
    let req = {
        intCreativeID: dataItem?.intCreativeID,
        action: 'delete',
        vchCreativeName: dataItem?.vchCreativeName,
        vchImageURL1: dataItem?.vchImageURL1,
        vchImageURL2: dataItem?.vchImageURL2,
        vchImageURL3: dataItem?.vchImageURL3,
        dteStartDate: dataItem?.dteStartDate,
        dteEndDate: dataItem?.dteEndDate,
    };
    setBtnLoading(true);
    const res = await serviceapi.actionOnCreative(req);
    setBtnLoading(false);
    if (res?.success) {
        const message = "Creative Deleted Successfully";
        setSelectedCreative(initival);
        enqueueSnackbar(message, {
            anchorOrigin: {
                vertical: "top",
                horizontal: "right",
            },
            variant: "success",
        });
        fetchCreativesList();
    } else {
        const message = "Error in Deleting Creative";
        enqueueSnackbar(message, {
            anchorOrigin: {
                vertical: "top",
                horizontal: "right",
            },
            variant: "error",
        });
    }
  };

  const handleCreativeSelect = async (creativeId) => {
    const req = {
      intStoreID: storage?.store?.intStoreID,
      intCreativeID: creativeId,
      bitActive: 1
    };
    setLoading(true);
    const res = await serviceapi.selectCreatives(req);
    enqueueSnackbar(res.success ? `Promotion applied successfully!` : "Something went wrong ! Please try again", {
      variant: res.success ? "success" : "error",
    });
    fetchCreativesList();
  }

  const serviceapi = new ServiceApi();

  useEffect(() => {
      fetchCreativesList();
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.success, props?.intStoreID]);

  const fetchCreativesList = async () => {
    setLoading(true);
    const res = await serviceapi.fetchStoreCreatives(props?.intStoreID);
    setLoading(false);
    const result = res?.data;
    const resultsData = result?.data;
    setNonMandatoryList(resultsData?.nonMandatory);
};
  const handlePromotion = (value, name) => {
    if (name === "Mandatory" && !value) {
      setSelectedCreative({
        ...selectedCreative,
        [name]: value,
        dteStartDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        dteEndDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      });
    } else if (name === "bitBannerType") {
      setSelectedCreative({ ...selectedCreative, [name]: value });
    } else {
      setSelectedCreative({ ...selectedCreative, [name]: value });
    }
  };

  const onSubmit = async () => {
    console.log(selectedCreative);
    let req = {
      intBannerID: selectedCreative?.intBannerID,
      bitActive: selectedCreative?.bitActive ? 1 : 0,
      intStoreID:props?.intStoreID
    };
    setBtnLoading(true);
    // if (action === "Add") {
    //   req = { ...req, intBannerID: 0 };
    // }
    const res = await serviceapi.UpdateStoreLevelPresellStatus(req);
    console.log(res);
    setBtnLoading(false);
    if (res?.success) {
      let message = "Promotion Added Successfully";
      if (action === "Update") {
        message = "Promotion Updated Successfully";
      }
      setShowDialog(false);
      setSelectedCreative(initival);
      fetchCreativesList();
      enqueueSnackbar(message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "success",
      });
    } else {
      let message = "Error in Adding Promotion";
      if (action === "Update") {
        message = "Error in Updating Promotion";
      }
      enqueueSnackbar(message, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      });
    }
  };

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading || btnloading}
        onClick={handleCloseDialog}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <main>
        <CreativesNonMandatoryPromotions
          loading={loading}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
          IsAdmin={false}
          promotionsList={nonMandatoryList}
          handleCreativeSelect={handleCreativeSelect}
        />
      </main>
      {showDialog ? (
        <AddPromotionDialog
          showDialog={showDialog}
          handleCloseDialog={handleCloseDialog}
          action={action}
          IsAdmin={false}
          selectedPromotion={selectedCreative}
          handlePromotion={handlePromotion}
          btnloading={btnloading}
          onSubmit={onSubmit}
          setSelectedPromotion={setSelectedCreative} 
          IsNonMandatory = {true}
        />
      ) : null}
    </>
  );
};

export default DMBPromosPreSellBoardConfiguration;
